module.exports = __webpack_public_path__ + "static/media/logo_MPDS_mini.76909365.svg";